export interface LoginStation {
  id: string
  index: string
  title: string
  caption: string
  top: string
  left: string
  labelAlign: 'left' | 'right'
}

export const loginStations: LoginStation[] = [
  {
    id: 'bastidor',
    index: '01',
    title: 'Bastidor',
    caption: 'La prenda se fija en el aro y sale con nombre. El inventario sigue ese mismo recorrido.',
    top: '80%',
    left: '34%',
    labelAlign: 'right'
  },
  {
    id: 'hilos',
    index: '02',
    title: 'Hilos',
    caption: 'Cada color tiene su puesto en el cabezal. Telas, tallas y categorías se ordenan con esa claridad.',
    top: '37%',
    left: '18%',
    labelAlign: 'right'
  },
  {
    id: 'linea',
    index: '03',
    title: 'Línea',
    caption: 'Las máquinas trabajan en fila. Ingresos, salidas y ventas quedan en el registro del turno.',
    top: '34%',
    left: '56%',
    labelAlign: 'left'
  }
]

export function nextLoginStationId(
  stations: readonly { id: string }[],
  activeId: string,
  direction: 1 | -1 = 1
) {
  if (!stations.length) return ''
  const index = stations.findIndex(station => station.id === activeId)
  if (index < 0) return stations[0]?.id ?? ''
  const next = stations[(index + direction + stations.length) % stations.length]
  return next?.id ?? stations[0]?.id ?? ''
}
